export default __webpack_public_path__ + "static/media/more.1cc7f679.mp3";